import { render, staticRenderFns } from "./ApprovedSelect.vue?vue&type=template&id=68337db4&"
import script from "./ApprovedSelect.vue?vue&type=script&lang=js&"
export * from "./ApprovedSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports